import {createUrl, getObject, getObjects, putObject} from "./api_common";

export const ENDPOINT_POSTS = '/api/posts'


export function getPosts(parameters = {}) {
    const defaultParameters = {
        //     isEdited: false,
    }

    let url = process.env.REACT_APP_API_URL + ENDPOINT_POSTS
    url = createUrl(url, parameters, defaultParameters)
    return getObjects(url)
}

export function getPost(id, parameters = {}) {
    let url = process.env.REACT_APP_API_URL + ENDPOINT_POSTS + '/' + id
    url = createUrl(url, parameters)
    return getObject(url)
}

export function putPost(postId, putValues = {}) {
    let url = process.env.REACT_APP_API_URL + ENDPOINT_POSTS + '/' + postId
    return putObject(url, putValues)
}